import { render, staticRenderFns } from "./AbkTextSectionForm.vue?vue&type=template&id=1826dadf&scoped=true&"
import script from "./AbkTextSectionForm.vue?vue&type=script&lang=js&"
export * from "./AbkTextSectionForm.vue?vue&type=script&lang=js&"
import style0 from "./AbkTextSectionForm.vue?vue&type=style&index=0&id=1826dadf&scoped=true&lang=scss&"
import style1 from "./AbkTextSectionForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1826dadf",
  null
  
)

export default component.exports